import { useMemo } from "react";
import { MoveAction } from "./useEdgeCrop";

export default function EdgeCropView({ coordinate, resizeCoordinate }) {
  const { left, top, bottom, right } = resizeCoordinate || coordinate;
  const width = right - left;
  const height = bottom - top;

  // 角落拖拽控件的宽度
  const controllStrokeWidth = 4;
  // 角落拖拽控件
  const cornerControl = useMemo(() => {
    return (
      <>
        <rect
          className="v2cropperHandle nw"
          fill="rgba(0,0,0,0)"
          height="20"
          stroke="none"
          width="20"
          x="0"
          y="0"
        ></rect>
        <path
          d="M22.5 2C17.9915 2 15.4046 2 12.9994 2C6.92422 2 2 6.92487 2 13V22"
          stroke="white"
          strokeWidth={controllStrokeWidth}
          strokeLinecap="round"
          fill="none"
        />
      </>
    );
  }, []);

  //上下左右边框控件宽度
  const edgeControllWidth = 4;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
      <defs>
        <mask id="mask">
          <rect fill="#fff" x="0" y="0" width="100%" height="100%"></rect>
          <rect
            id="hole"
            x={left}
            y={top}
            width={width}
            height={height}
            rx="4"
            ry="4"
          />
        </mask>
      </defs>
      {/* 阴影遮罩 */}
      <rect
        x={0}
        y={0}
        width={"100%"}
        height={"100%"}
        fill="rgba(0,0,0,0.5)"
        mask="url(#mask)"
        data-move-action={MoveAction.resize}
      />
      {/* 中间透明部分 */}
      <use
        fill="rgba(0,0,0,0)"
        href="#hole"
        stroke="white"
        strokeWidth="1"
        style={{ cursor: "move" }}
        data-move-action={MoveAction.whole}
      ></use>
      {!resizeCoordinate && (
        <>
          {/* left */}
          <g
            transform={`translate(${left - edgeControllWidth / 2} ${top})`}
            style={{ cursor: "ew-resize" }}
            data-move-action={MoveAction.left}
          >
            <rect
              fill="rgba(0,0,0,0)"
              width={edgeControllWidth}
              height={bottom - top}
              stroke="none"
            ></rect>
          </g>
          {/* top */}
          <g
            style={{ cursor: "ns-resize" }}
            transform={`translate(${left} ${top - edgeControllWidth / 2})`}
            data-move-action={MoveAction.top}
          >
            <rect
              fill="rgba(0,0,0,0)"
              width={right - left}
              height={edgeControllWidth}
              stroke="none"
            ></rect>
          </g>
          {/* right */}
          <g
            transform={`translate(${right - edgeControllWidth / 2} ${top})`}
            style={{ cursor: "ew-resize" }}
            data-move-action={MoveAction.right}
          >
            <rect
              fill="rgba(0,0,0,0)"
              width={edgeControllWidth}
              height={bottom - top}
              stroke="none"
            ></rect>
          </g>
          {/* bottom */}
          <g
            style={{ cursor: "ns-resize" }}
            transform={`translate(${left} ${bottom - edgeControllWidth / 2})`}
            data-move-action={MoveAction.bottom}
          >
            <rect
              fill="rgba(0,0,0,0)"
              width={right - left}
              height={edgeControllWidth}
              stroke="none"
            ></rect>
          </g>
          {/* 左上角 */}
          <g
            style={{ cursor: "nwse-resize" }}
            transform={`translate(${left - controllStrokeWidth} ${
              top - controllStrokeWidth
            }), rotate(0)`}
            data-move-action={MoveAction.topLeft}
          >
            {cornerControl}
          </g>
          {/* 右上角 */}
          <g
            style={{ cursor: "nesw-resize" }}
            transform={`translate(${right + controllStrokeWidth} ${
              top - controllStrokeWidth
            }), rotate(90)`}
            data-move-action={MoveAction.topRight}
          >
            {cornerControl}
          </g>
          {/* 右下角 */}
          <g
            style={{ cursor: "nwse-resize" }}
            transform={`translate(${right + controllStrokeWidth} ${
              bottom + controllStrokeWidth
            }), rotate(180)`}
            data-move-action={MoveAction.bottomRight}
          >
            {cornerControl}
          </g>
          {/* 左下角 */}
          <g
            style={{ cursor: "nesw-resize" }}
            transform={`translate(${left - controllStrokeWidth} ${
              bottom + controllStrokeWidth
            }), rotate(270)`}
            data-move-action={MoveAction.bottomLeft}
          >
            {cornerControl}
          </g>
        </>
      )}
    </svg>
  );
}
